// TODO: (kirill) bring in typed event bus
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EventListenerArgs = [type: string, callback: (event: Event & { detail?: unknown }) => any]
export default class EventBus {
    // for now, not marking this as private,
    // because it makes Vue types a mess for AdMediator/AdMediatorVueInstance. See:
    // https://github.com/vuejs/language-tools/issues/1857 and https://github.com/vuejs/core/issues/2981#issuecomment-1831724017
    readonly elem: HTMLElement

    constructor() {
        this.elem = document.createElement('b')
    }

    addEventListener(...args: EventListenerArgs) {
        this.elem.addEventListener(...args)
    }

    removeEventListener(...args: EventListenerArgs) {
        this.elem.removeEventListener(...args)
    }

    dispatch(event: string, payload?: unknown) {
        this.elem.dispatchEvent(new CustomEvent<unknown>(event, { detail: payload }))
    }
}
